<div class="modal-header"><h2 class="modal-title">Batch</h2></div>
<div class="modal-body">
  @if (batch) {
    <div>
      <dx-form [formData]="batch" validationGroup="validationGroup" [colCount]="2">
        <dxi-item dataField="date"></dxi-item>
        <dxi-item itemType="empty"></dxi-item>
        <dxi-item dataField="name" [colSpan]="2">
          @if (appInfo.graafschap) {
            <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
          }
        </dxi-item>
        @if (specialAccounts) {
          <dxi-item [label]="{ text: 'Special Accounts' }">
            <div *dxTemplate>
              <dx-select-box
                [(value)]="batch.specialAccountId"
                [items]="specialAccounts"
                valueExpr="id"
                displayExpr="{{ this.graafschap ? 'accountName' : 'name' }}"
                (onValueChanged)="specialAccountChange($event)"
                (onOpened)="adjustWidth($event)"
                (onContentReady)="adjustWidth($event)"
                >
              </dx-select-box>
            </div>
            @if (appInfo.graafschap) {
              <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
            }
          </dxi-item>
        }
        <dxi-item dataField="bagNumber"></dxi-item>
        <dxi-item [label]="{ text: 'Note' }" [colSpan]="2">
          <div *dxTemplate><dx-text-area [(value)]="batch.note" [height]="100"></dx-text-area></div>
        </dxi-item>
        <dxi-item
          dataField="statusId"
          [label]="{ text: 'Status' }"
          editorType="dxSelectBox"
          [editorOptions]="{ items: statuses, valueExpr: 'id', displayExpr: 'name', readOnly: statusReadOnly }"
        ></dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button> <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
